module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/123live-fullcolor.svg?c460d535e24c5627f2ca21361f283744";